import { Minus } from 'react-feather'

import { GetMyInfosQuery } from '@/core/graphql/types'

type NotesProps = {
  consultation: GetMyInfosQuery['myInfos']['consultations'][number]
}

export function Notes({ consultation }: NotesProps) {
  return (
    <section className="flex flex-col gap-2 w-full">
      <h3 className="section-title">Notes</h3>
      <div className="shadow bg-white rounded-lg p-4 md:p-5">
        <p className="capitalize ">{consultation.commentaire ? consultation.commentaire : <Minus className="text-zinc-500 text-md" />}</p>
      </div>
    </section>
  )
}
